module.exports = __webpack_public_path__ + "static/social-b806be8786c20258818c8cf1451d70d6.jpg";